/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// eslint-disable-next-line
function cartUpsellProducts(opts) {
  const config = {
    dom: {
      parent: 'cartItems',
      cartItem: 'js-cart-item',
      upsellWrapper: 'js-upsell-wrapper',
      upsellATC: 'js-upsell-atc',
      upsellProducts: 'js-upsell-products',
      upsellCancel: 'js-upsell-cancel',
      upsellData: 'upsellData',
      showBtn: 'js-acc-btn',
    },
    cls: {
      hide: 'hide',
      plus: 'plus',
      minus: 'minus',
    },
  };
  const c = _.extend(config, opts);

  const $parent = document.getElementById(c.dom.parent);
  const $upsellData = document.getElementById(c.dom.upsellData);

  /**
   * Init
   */
  function init() {
    if ($parent) {
      addEvents();
      removeUpsellsWithNoParent();
    }
  }

  /**
   * Add events
   */
  function addEvents() {
    _.addEvent({
      id: $parent,
      event: 'click',
      fn: addToCart,
      className: c.dom.upsellATC,
    });

    _.addEvent({
      id: $parent,
      event: 'click',
      fn: showUpsells,
      className: c.dom.upsellCancel,
    });

    _.addEvent({
      id: $parent,
      event: 'click',
      fn: showUpsells,
      className: c.dom.showBtn,
    });
  }

  /**
   * Toggle upsell accordion
   * @param {object} e - click event
   */
  function showUpsells(e) {
    const $target = e.target;
    const $upsellWrapper = _.parents($target, `.${c.dom.upsellWrapper}`)[0];
    const $upsellProducts = $upsellWrapper.querySelector(`.${c.dom.upsellProducts}`);
    const $showBtn = $upsellWrapper.querySelector(`.${c.dom.showBtn}`);

    if (!_.hasClass($upsellProducts, c.cls.hide)) {
      _.addClass($upsellProducts, c.cls.hide);
      _.removeClass($showBtn, c.cls.minus);
    } else {
      _.removeClass($upsellProducts, c.cls.hide);
      _.addClass($showBtn, c.cls.minus);
    }
  }

  /**
   * Returns variant id of the upsell product to add for this line item
   * @param {string} key - line item key of cart item
   */
  function getCheckedValue(key) {
    const checked = document.querySelector(`input[name="cart-item-${key}"]:checked`);
    if (!checked) return false;
    return checked.value;
  }

  /**
   * Add to cart
   * @param {object} e - click event
   */
  function addToCart(e) {
    const $target = e.target;
    const $upsellWrapper = _.parents($target, `.${c.dom.upsellWrapper}`)[0];
    const $cartItem = $upsellWrapper.previousElementSibling;
    const parentKey = $cartItem.dataset.key;
    const variantId = getCheckedValue(parentKey);
    if (variantId) {
      // trying to pass custom data for later formatting
      const upsellData = {
        id: variantId,
        quantity: 1,
        properties: {
          _parentKey: parentKey,
        },
      };

      const url = `${window.routes.cartAddUrl}.js`;

      _.ajax({
        data: JSON.stringify(upsellData),
        contentType: 'application/json',
        error: (error) => { console.log('error', error); },
        success: () => {
          // cart refresh
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        },
        type: 'POST',
        url,
      });
    }
  }

  /**
   * Remove upsells with no parent product
   */
  function removeUpsellsWithNoParent() {
    if (!$upsellData) return;

    const {
      upsellItemsArray,
      upsellItemsHasParentArray,
    } = $upsellData.dataset;

    const upsellItems = JSON.parse(upsellItemsArray);
    const upsellItemsWithParents = JSON.parse(upsellItemsHasParentArray);

    const upsellItemsToRemove = upsellItems.filter((i) => !upsellItemsWithParents.includes(i));

    if (upsellItemsToRemove.length) {
      const updates = {};
      upsellItemsToRemove.forEach((item) => {
        updates[item] = 0;
      });

      const url = `${window.routes.cartUrl}/update.js`;
      _.ajax({
        data: JSON.stringify({ updates }),
        contentType: 'application/json',
        error: (error) => { console.log('error', error); },
        success: () => {
          // cart refresh
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        },
        type: 'POST',
        url,
      });
    }
  }

  return init();
}
